<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="审核状态"
      >
        <el-option
          v-for="(item, i) in finishData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: {},
      finishData: [],
    };
  },
  created() {
    getDataMap("AUDIT_STATUS").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      res.data.pop();
      this.finishData = res.data;
    });
  },
  methods: {
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
.pro_input {
  width: 120px;
  margin-right: 10px;
}
</style>
